import { graphql } from '@/gql';

import './GroceryStoreFragment';

graphql(`
  fragment GroceriesRowFragment on GroceryType {
    id
    name
    orderId
    cartId
    orderUUId
    callerId
    customerName
    timeZone
    email
    address
    streetAddress
    streetAddress2
    city
    zip
    state
    country
    latitude
    longitude
    priorityLevel
    status
    currency
    notes
    orderNotes
    transactionId
    instruction
    userId
    orderedByName
    timeReceived
    timeShopping
    timeShoppingComplete
    timeInTransit
    timeCompleted
    timeCanceled
    paidStatus
    canceledBy
    canceledById
    canceledByName
    reasonForCanceling
    noGoGoFee
    noGoGoFeeReason
    tip
    totalCost
    gogoFee
    gogoCost
    discount
    isTipable
    isSavedGrocery
    assignedOperatorId
    isConfirmedAddressAndNotes
    isInteractedWithShopper
    preauthChargeAmount
    driverId
    groceryStoreId
    storeName
    storeLogo
    driverName
    initialEstimateStartAt
    initialEstimateEndAt
    estimateStartAt
    estimateEndAt
    chatLink
    createdAt
    updatedAt
    store {
      ...GroceryStore
    }
    storeItems {
      initialQty
      groceryItem {
        id
      }
      replacementPolicy
      instruction
      replacementItem {
        id
      }
      replacementItemId
      replacementItemQty
    }
    driver {
      id
      firstName
      photo
    }
    needLoves {
      id
      groceryId
      operatorId
      type
      status
      resolution
      fields {
        name
        value
      }
      comments {
        name
        comment
        createdAt
      }
      createdAt
      updatedAt
      operator {
        id
        firstName
        lastName
      }
    }
    assignedOperator {
      id
      firstName
      lastName
    }
    caller {
      firstName
      lastName
      phoneNumber
    }
  }
`);
